import * as actionTypes from "./../../Constants/clients/clientActionTypes";

export function isHotEdited (edited = false ) {
    return{
        type: actionTypes.IS_EDITED,
        payload: { edited }
    }
}

export function isEdited(edited) {
    return dispatch => {
        return dispatch(isHotEdited(edited));
    };
}